<template>
  <div class="evaluate-report-comp">
    <div
      v-for="(item) in list"
      :key="item.id"
      class="evaluate-report-item"
      @click="showDetail(item)">
      <div class="base-line flex-between">
        {{ item.title }}
        <van-icon name="arrow" color="var(--g5)" v-if="canGoDetail(item)"></van-icon>
      </div>
      <div class="card-bottom flex-between">
        <div class="desc-line">{{ item.time | formatDatetime('yyyy-MM-dd') }}</div>
        <div class="desc-line">{{ item.teacherName }}</div>
      </div>
    </div>
    <van-empty
      image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png"
      description="当前还没有测评报告"
      v-if="!list||(list&&list.length==0)"
      image-size="128">
    </van-empty>
  </div>
</template>

<script>
export default {
  name: 'evaluate-report-comp',
  props: {
    list: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  methods: {
    showDetail(item) {
      if (item.type == 1 && this.canGoDetail(item)) { // type: 1测评中心测评报告 2阶段测评报告
        this.$router.push(`/cepingDetail/${item.id}`)
      } 
      if (item.type == 2 && this.canGoDetail(item)) {
        this.$router.push(`/evaluation-detail/${item.id}`);
      }
    },
    canGoDetail(item) {
      if (item.type == 1) {
        return app.permission.op('evaluation');
      } else if (item.type == 2) {
        return app.permission.op('query_archives_stage_test');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.evaluate-report-comp {
  .evaluate-report-item {
    margin: calc(var(--gap) * 16) calc(var(--gap) * 16) calc(var(--gap) * 12);
    padding: 0 calc(var(--gap) * 16);
    border-radius: var(--radius-sm);
    background-color: var(--white);
    .base-line {
      font-size: var(--fs-md);
      line-height: var(--lh-md);
      padding: calc(var(--gap) * 12) 0;
    }
    .card-bottom {
      padding-bottom: calc(var(--gap) * 8);
      .desc-line {
        color: var(--g6);
        font-size: var(--fs-sm);
        line-height: var(--lh-sm);
      }
    }
  }
}
</style>